import React from 'react'
import {useState,useEffect} from 'react';

import firstChillhop from '../media/ny90.mp3';
import simon_sloth from '../images/simon_sloth.png'

const audioClips = [
  {sound: firstChillhop, label: 'firstChillhop'}
]


function OpenSeaDial(props){
  const {toggle} = props;
  return(
      <div class='flex'>

<div onClick={() => toggle()} class='bg-sky-700 hover:pr-8 duration-150 mx-auto rounded-full  text-[0px] hover:text-base cursor-pointer'>
<img  class='mx-auto h-16  rounded-full inline-block  ' src={simon_sloth}></img>
<h1 class='inline-block text-center '>{"View On Opensea"}</h1>
</div>
</div>
  )
}

const useAudio = url => {
  const [audio] = useState(new Audio(firstChillhop));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing]
  );
  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

const Player = ({ url }) => {
  const [playing, toggle] = useAudio(url);


  return (
    <div className='vibesContainer top-[70%] fixed bottom-0 left-0 right-0'>
      {/* <button className ='vibeButton' onClick={toggle}>{playing ? "Pause" : "Play"}</button> */}
      {playing && 
      
        // <div class='flex '>

        // <button onClick={toggle}  className = 'vibesMascot'>Heyy</button>
        // <img class='rounded-full inline-block cursor-pointer h-32 text-[0]' src={simon_sloth}></img>
        // <h1 class='inline-block bg-white rounded-full h-32'>We're Playing Music</h1>
        // </div> 
        <OpenSeaDial toggle={toggle}/>

        
      }
      {!playing && 
      // <span class='flex'>
      //   <button onClick={toggle}  className = 'vibesMascot'>Heyy</button>
      //   <img class='rounded-full inline-block  cursor-pointer h-32 text-[0]' src={simon_sloth}></img>
      //   <h1 class='inline-block bg-white rounded-full h-32'>We're Playing Music</h1>
      //   </span>
      <OpenSeaDial toggle={toggle}/>
        }

    </div>
  );
};




const VibeStation = () => {

  
  return (
 
   
    <>    
    
    <Player/>


    </>
  )
}

export default VibeStation